import React from 'react'
import { Button } from 'antd'
import styled from 'styled-components'
import SuccessIcon from '../../../asserts/icon/questionnaire/ic_questionnaire_pre_medical_success.svg'
import WarningIcon from '../../../asserts/icon/questionnaire/ic_questionnaire_pre_medical_warning.svg'

const Container = styled.div`
  width: 576px;
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  h1 {
    color: #323f4a;
    font-size: 36px;
    margin-bottom: 36px;
  }
  img {
    margin-bottom: 36px;
  }
  .content {
    color: #52606c;
    font-size: 16px;
    font-family: 'Heebo';
    font-weight: 400;
    letter-spacing: 0.3px;
    line-height: 150%;
  }
  button {
    width: 229px;
    height: 48px;
    margin-top: 20px;
  }
`

export default function CompletedMessage(props) {
  const { type, goNext, logOut } = props
  const isYes = type === 'yes'
  return (
    <Container>
      <img src={isYes ? WarningIcon : SuccessIcon} alt="completed" />
      {isYes ? (
        <div className="content">
          <p>
            Thank you for completing our pre-assessment Medical Review. Your
            health and safety is a top priority for us. Based on your responses,
            please make sure that your primary physician approves your
            participation in our assessment. If your physician has any
            recommended modifications, please let us know and we will
            incorporate these in your assessment. If you have additional
            questions, please email{' '}
            <a href="mailto:partnerships@apeiron.life">
              partnerships@apeiron.life.
            </a>
            .
          </p>
          <Button type="primary" size="large" onClick={logOut}>
            LOG OUT
          </Button>
        </div>
      ) : (
        <div className="content">
          <p>
            Thank you for completing our pre-assessment Medical Review. Please
            click "NEXT" to add your logistical details and sign our waiver
            (this should take about 5-10 minutes).
          </p>
          <p>
            Once these forms are completed, our Concierge team will reach out to
            schedule the rest of your Apeiron appointments. We look forward to
            learning more about you and supporting your health and well-being!
          </p>
          <Button size="large" type="primary" onClick={() => goNext()}>
            NEXT
          </Button>
          {/* <br /> */}
          {/* <Button
            style={{ width: 229, padding: 0, marginTop: 16 }}
            size="large"
            type="primary"
            ghost
            onClick={logOut}
          >
            I WILL COME BACK LATER
          </Button> */}
        </div>
      )}
    </Container>
  )
}
